export const recordDataSensitivities = [
  { key: 'sensitivitiesHasHumanInformation', label: 'Human information, their biospecimens, or data' },
  { key: 'sensitivitiesClinicalTrialInformation', label: 'Research data generated through a clinical trial' },
  { key: 'sensitivitiesGeneTherapies', label: 'Data related to gene therapies' },
  { key: 'sensitivitiesPersonalInformation', label: 'Identified or reasonably identifiable individual information' },
  { key: 'sensitivitiesSensitiveGeneralInformation', label: 'Sensitive personal information' },
  { key: 'sensitivitiesHealthInformation', label: 'Health information about an individual' },
  { key: 'sensitivitiesGeneticInformation', label: 'Genetic information' },
  { key: 'sensitivitiesBiometricInformation', label: 'Biometric information' },
  { key: 'sensitivitiesBiometricTemplates', label: 'Biometric templates' },
  {
    key: 'sensitivitiesAboriginalTorresStraitIslander',
    label: 'Aboriginal and/or Torres Strait Islander sensitivities',
  },
  { key: 'sensitivitiesCommercialInConfidenceInformation', label: 'Commercial-in-confidence information' },
  { key: 'sensitivitiesSensitiveEcologicalInformation', label: 'Sensitive ecological information' },
  { key: 'sensitivitiesSsbaInformation', label: 'Information on Security Sensitive Biological Agents (SSBAs)' },
]

export const recordDataSensitivityKeys = recordDataSensitivities.map((item) => item.key)

export const getRecordDataSensitivities = (recordMeta: Record<string, unknown>) => {
  return Object.entries(recordMeta)
    .filter(([key, value]) => {
      return (
        recordDataSensitivityKeys.includes(key as (typeof recordDataSensitivityKeys)[number]) &&
        value !== null &&
        value !== undefined &&
        !(typeof value === 'string' && value.trim() === '') &&
        !(Array.isArray(value) && value.length === 0)
      )
    })
    .sort(
      ([keyA], [keyB]) =>
        recordDataSensitivityKeys.indexOf(keyA as (typeof recordDataSensitivityKeys)[number]) -
        recordDataSensitivityKeys.indexOf(keyB as (typeof recordDataSensitivityKeys)[number]),
    )
}
